export enum PRODUCT_TYPES {
  PRODUCT = 0,
  UNIT = 1,
  DEVICE = 2,
}

export const ProductTypeStrings: Record<PRODUCT_TYPES, string> = {
  [PRODUCT_TYPES.PRODUCT]: 'Producto',
  [PRODUCT_TYPES.UNIT]: 'Unidad',
  [PRODUCT_TYPES.DEVICE]: 'Dispositivo',
};
